<template>
  <div>
    <LoadingContainer v-if="loading"/>

    <div v-else>
      <FormPanel
          :initial="sitemapLink.attributes"
          headline="Edit Sitemap Link"
          :errors="errors"
          @submit="submit"
      />
    </div>
  </div>
</template>

<script>
import http from '@/http'
import notify from '@/notify'
import FormPanel from '../../../../../../../components/Administration/SitemapLinks/Panels/Form'
import LoadingContainer from '../../../../../../../components/Layout/LoadingContainer'

export default {
  components: {LoadingContainer, FormPanel},

  props: {
    portal: {
      required: true
    },

    blockDrivers: {
      required: true
    },

    layoutCategories: {
      required: true
    }
  },

  data() {
    return {
      sitemapLink: null,
      loading: true,

      errors: {}
    }
  },

  mounted() {
    this.load()
  },

  methods: {
    load() {
      http.get('/api/v2/sitemap-links/' + this.$route.params.sitemapLinkId).then(response => {
        this.sitemapLink = response.data.data

        this.loading = false
      })
    },

    submit(data) {
      http.put('/api/v2/sitemap-links/' + this.$route.params.sitemapLinkId, data)
          .then(response => {
            notify.success('The sitemap link was saved')

            this.sitemapLink = response.data.data

            this.errors = {}
          })
          .catch(error => {
            if (error.response.status === 422) {
              this.errors = error.response.data.errors
            }

            throw error
          })
    },
  }
}
</script>
